<template>
  <div class="chartdiv" ref="chartdiv" />
</template>

<script>
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  am4core.useTheme(am4themes_animated);

  const data = [{
    month: "3",
    mass: 13278.70,
    distance: 121048.18,
    ton: 3.12,
    price: 378220.00
  }, {
    month: "4",
    mass: 4592.25,
    distance: 60999.34,
    ton: 2.91,
    price: 177565.00
  }, {
    month: "7",
    mass: 58628.84,
    distance: 335371.28,
    ton: 4.82,
    price: 1617305.00,
  }, {
    month: "8",
    mass: 40382.67,
    distance: 368870.82,
    ton: 3.52,
    price: 1298080.00,
  }, {
    month: "9",
    mass: 37233.39,
    distance: 328795.98,
    ton: 3.65,
    price: 1199610.00,
  }, {
    month: "10",
    mass: 80850.45,
    distance: 814558.17,
    ton: 4.07,
    price: 3311423.00,
  }, {
    month: "11",
    mass: 87097.42,
    distance: 957675.89,
    ton: 3.93,
    price: 3765732.00,
  }, {
    month: "12",
    mass: 54561.42,
    distance: 370012.72,
    ton: 4.22,
    price: 1562425.00,
  }];

  export default {
    data() {
      return {
        chart: null
      };
    },

    mounted() {
      const chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

      chart.paddingRight = 20;
      chart.data = data;

      // Create axes
      const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "month";
      categoryAxis.title.text = "Номера месяца";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 20;

      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Суммы по полям (руб.)";

      // Create series
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "mass";
      series.dataFields.categoryX = "month";
      series.name = "Сумма по полю Масса разгруженная";
      series.columns.template.tooltipText = "{categoryX}\n[bold]{valueY}[/]";

      const series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "distance";
      series2.dataFields.categoryX = "month";
      series2.name = "Сумма по полю Дистанция, км";
      series2.columns.template.tooltipText = "{categoryX}\n[bold]{valueY}[/]";

      const series3 = chart.series.push(new am4charts.ColumnSeries());
      series3.dataFields.valueY = "ton";
      series3.dataFields.categoryX = "month";
      series3.name = "Сумма по полю Тонна/км";
      series3.columns.template.tooltipText = "{categoryX}\n[bold]{valueY}[/]";

      const series4 = chart.series.push(new am4charts.LineSeries());
      series4.dataFields.valueY = "price";
      series4.dataFields.categoryX = "month";
      series4.name = "Сумма по полю ЦЕНА_ДЛЯ_ГП_разгр_За_Тонну";
      series4.strokeWidth = 3;

      // Add legend
      chart.legend = new am4charts.Legend();
      chart.legend.position = 'right';
      chart.legend.maxWidth = undefined;

      this.chart = chart;
    },

    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose();
      }
    }
  }
</script>

<style scoped>
  .chartdiv {
    width: 1200px;
    height: 500px;
  }
</style>